/*
  PDP richtext-popup tooltips — extracted from sections/gg-product-pdp.liquid. Delegated
  document listeners, so running deferred after parse is equivalent to the old inline block.
*/
document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-tooltip-toggle');

    document.querySelectorAll('.richtext-popup-row__tooltip').forEach(function(tip) {
      if (!trigger || trigger.getAttribute('aria-controls') !== tip.id) {
        tip.hidden = true;
      }
    });

    document.querySelectorAll('.js-tooltip-toggle').forEach(function(btn) {
      if (btn !== trigger) btn.setAttribute('aria-expanded', 'false');
    });

    if (!trigger) return;

    e.preventDefault();

    const tooltipId = trigger.getAttribute('aria-controls');
    const tooltip = document.getElementById(tooltipId);
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    trigger.setAttribute('aria-expanded', String(!isOpen));
    tooltip.hidden = isOpen;
  });

  document.addEventListener('keydown', function(e) {
    const trigger = e.target.closest('.js-tooltip-toggle');

    if (trigger && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      trigger.click();
      return;
    }

    if (e.key === 'Escape') {
      document.querySelectorAll('.richtext-popup-row__tooltip').forEach(function(tip) {
        tip.hidden = true;
      });
      document.querySelectorAll('.js-tooltip-toggle').forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
